import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { clearUpdatedApplication, updateApplicationExam } from '../../../store/actions/applicationsActions'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import NumberField from '../../elements/form/NumberField'

const AddExamScore = ({application, schedule, closeFunction, reload, description, examination}) => {
    const dispatch = useDispatch()
    const applicationsSelector = useSelector((state => state.applications))

    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        if(applicationsSelector.updatedApplication !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'applicant score updated successfully!'
            })
            dispatch(clearUpdatedApplication())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationsSelector.updatedApplication, closeFunction, dispatch]);


    const validateForm = () => {
        let errors = {}


        if(!score || score === '') {
            errors.score = true
        }


        setValidationErrors(errors)

        return errors
    }

    const [score, setScore] = useState(null);

    const pushScore = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        dispatch(updateApplicationExam(application._id, {
            examination: schedule._id,
            examScore: score
        }))

    }

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>{description}</p>
            </div>
            <div className='mt-4 relative'>
                <div className='w-full my-2'>
                    <NumberField
                        inputType="number" 
                        fieldId={`exam-score`}
                        inputLabel="Applicant's exam score (Percentage)" 
                        requiredField={true}
                        preloadValue={score || ''}
                        hasError={validationErrors.score} 
                        returnFieldValue={(value)=>{setScore(value)}}
                    />
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update applicant score`}
                    buttonAction={()=>{pushScore()}}
                    processing={applicationsSelector.updatingApplication}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default AddExamScore